export default "__VITE_ASSET__B$$v9EuC__"